'use client';

import ProgressAnime from '@/components/ui/ProgressAnime/ProgressAnime';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useEffect, useRef, useState } from 'react';
import { getEcItemList } from '../../api/getEcItemList';
import { EcItemListItem } from '../../types';
import ECommerceSearchNotFound from '../ECommerceSearchNotFound/ECommerceSearchNotFound';
import EcItemList from '../EcItemList/EcItemList';

function EcItemInfiniteList({
  ecItems,
  pageLimit,
  query,
  requestTime,
  contentType,
  bizCreatorId,
  bizTeamId,
  hasStock = false,
  isSearchList = true,
}: {
  ecItems: Array<EcItemListItem>;
  pageLimit: number;
  query?: string;
  requestTime: string;
  contentType?: string;
  bizCreatorId?: number;
  bizTeamId?: number;
  hasStock?: boolean;
  isSearchList?: boolean;
}) {
  const [hasNoMore, setHasNoMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentEcItemsList, setCurrentEcItemsList] = useState(ecItems);
  const targetRef = useRef<HTMLDivElement>(null);

  function handleScroll() {
    const scrollingBottom = targetRef.current?.getBoundingClientRect().bottom;
    if (!scrollingBottom) return;
    if (canFetch(scrollingBottom)) {
      fetchMore();
    }
  }

  const fetchMore = async () => {
    setIsLoading(true);
    window.removeEventListener('scroll', handleScroll); //一回削除
    const lastId = currentEcItemsList.slice(-1)[0].id;

    const { result: moreEcItemsList } = await getEcItemList({
      oemServiceId: Number(process.env.NEXT_PUBLIC_SERVICE_ID),
      requestTime: requestTime,
      getType: hasStock ? 'has_stock' : 'new',
      paging: 'next',
      limit: pageLimit,
      itemName: query || undefined,
      pagingEcItemId: lastId,
      contentType: contentType || undefined,
      bizCreatorId: bizCreatorId || undefined,
      bizTeamId: bizTeamId || undefined,
    });
    if (moreEcItemsList.length === 0) {
      setHasNoMore(true);
      setIsLoading(false);
      return;
    }
    setCurrentEcItemsList([...currentEcItemsList, ...moreEcItemsList]);
    setIsLoading(false);
    window.addEventListener('scroll', handleScroll); //　終わったら追加
  };

  const canFetch = (scrollingBottom?: number) => {
    if (!scrollingBottom) return false;
    return scrollingBottom < window.innerHeight + 60 && !hasNoMore && !isLoading && ecItems.length > 0;
  };

  useEffect(() => {
    // スクロール処理
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentEcItemsList]);

  return (
    <>
      {currentEcItemsList.length > 0 ? (
        <div ref={targetRef}>
          <EcItemList ecItems={currentEcItemsList}></EcItemList>
          {isLoading && <ProgressAnime></ProgressAnime>}
        </div>
      ) : (
        <div className={utilsStyles.mtLarge}>
          {isSearchList ? (
            <ECommerceSearchNotFound></ECommerceSearchNotFound>
          ) : (
            <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold} ${utilsStyles.textCenter}`}>
              デジタルコンテンツがありません
            </p>
          )}
        </div>
      )}
    </>
  );
}

export default EcItemInfiniteList;
